export default __webpack_public_path__ + "static/media/NI-GT2003.36d3690d.jpg";